import HttpApi from '@/utils/HttpApi'
import { UserEntity } from '@/models/UserEntity'

interface CanRunQueries {
    canRunQueries: boolean
}

export default class UserApi {
    public static async postLogin(credentials: CredentialEntity) {
        return await HttpApi.post<UserEntity>('login', credentials)
    }

    public static async postGoogleLogin(credentials: GoogleLoginCredentialEntity) {
        return await HttpApi.post<UserEntity>('login-with-google', credentials)
    }

    public static async canRunQueries() {
        return await HttpApi.get<CanRunQueries>('canRunQueries')
    }
}
